import { Box } from '@mui/material';

import React from 'react';

const LoginRightPanel = React.lazy(() => import('./LoginRightPanel'));
const LoginPanel = React.lazy(() => import('MyAccountPlus-UIComponents/src/components/login-panel/LoginPanel'));

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { loginActions, loginThunk } from '../../../store/login-reducer/loginSlice';

const LoginLayout = () => {

    const dispatch = useAppDispatch();
    const { loading, error } = useAppSelector((state) => state.loginStore);

    const userLoginInfo = sessionStorage.userInfo && JSON.parse(sessionStorage.userInfo);

    const handleCloseHandler = () => {
        dispatch(loginActions.errorReducer());
    };
    const handleSubmitHandler = (data: any) => {
        dispatch(loginThunk(data));
    };

    return (
        <Box className="login-main-container">
            <LoginPanel
                loading={loading}
                error={error}
                errorHandler={handleCloseHandler}
                handleSubmitHandler={handleSubmitHandler}
                showNote={false}
                userLoginInfo={userLoginInfo}
            />
            <LoginRightPanel />
        </Box>
    )
}

export default LoginLayout;